const ar = {
  Signin: "تسجيل الدخول",
  Signup: "إنشاء حساب",
  Setting: "الإعدادات",
  Logout: "تسجيل الخروج",
  Welcome: "مرحبًا",
  Name: "الاسم",
  Email: "البريد الإلكتروني",
  Message: "الرسالة",
  "Start the success of your website with us": "ابدأ نجاح موقعك معنا",
  Send: "إرسال",
  "Let's talk": "دعنا نتحدث",
  Features: "الميزات",
  "About Us": "معلومات عنا",
  Pricing: "التسعير",
  Home: "الرئيسية",
  Guest: "ضيف",
  USD: "دولار أمريكي",
  month: "شهر",
  "Billed Monthly": "يتم الفوترة شهريًا",
  "Billed Yearly": "يتم الفوترة سنويًا",
  Monthly: "شهريًا",
  Yearly: "سنويًا",
  "Quick links": "روابط سريعة",
  "Head Office": "المكتب الرئيسي",
  "3041 Alasaker St an nuzha Riyadh": "3041 شارع العسكر، حي النزهة، الرياض",
  "All rights reserved": "جميع الحقوق محفوظة",
  "Features That Live Up To Your Taste And Enable You To Work":
    "ميزات ترقى إلى ذوقك وتمكنك من العمل",
  "With A Few Clicks, You Will Have Launched Your Electronic Identity In The Internet Space, With An Unprecedented Quality That Has Been Meticulously Developed To Meet The Most Important Details.":
    "بنقرات قليلة ستكون قد انطلقت هويتك الإلكترونية في فضاء الإنترنت، بجودة غير مسبوقة تم تطويرها بدقة لتلبي أهم التفاصيل.",
  "Technology developed from scratch": "التكنولوجيا المتقدمة من الصفر",
  "You can directly sell your service or product":
    "يمكنك بيع خدمتك أو منتجك مباشرة",
  "Your service or product can be added and made available to your customers without complications.":
    "يمكن إضافة خدمتك أو منتجك وإتاحته لعملائك دون تعقيدات.",
  "With ease, enjoy personalized mail for your business":
    "استمتع بسهولة بالبريد المخصص لعملك",
  "Add your custom mail to your domain and to all your employees without the need for a specialist.":
    "أضف بريدك المخصص إلى نطاقك وإلى جميع موظفيك دون الحاجة إلى متخصص.",
  "The development was carried out with international technologies, and you also made custom development with expert touches to be unique in high performance.":
    "لقد تم التطوير بتقنيات عالمية، وقمتم أيضًا بتطوير مخصص بلمسات احترافية لتكون فريدة من نوعها في الأداء العالي.",
  "Customize your website": "خصص موقعك الإلكتروني",
  "Buy your domain": "اشترِ نطاق موقعك اليوم!",
  "Start Creating Today!": "ابدأ الإبداع اليوم!",
  "Your landing page with ease and show up to your  customers in a professional way":
    "صفحتك المقصودة بسهولة واظهر لعملائك بطريقة احترافية",
  "Get Started": "ابدأ",
  "Simply put, prices that match your budget": "ببساطة، أسعار تناسب ميزانيتك",
  "Enjoy the monthly or annual plan, with suitable features and functions, at prices that suit everyone.":
    "استمتع بالخطة الشهرية أو السنوية، مع ميزات ووظائف مناسبة، بأسعار تناسب الجميع.",
  "Basic Plan": "الخطة الأساسية",
  "Standard Plan": "الخطة القياسية",
  "Advanced Plan": "الخطة المتقدمة",
  "Landing page": "الصفحة المقصودة",
  "Innovative control panel variable": "لوحة تحكم مبتكرة ومتغيرة",
  "Customize Content": "تخصيص المحتوى",
  "Theme link to your own domain": "رابط القالب إلى نطاقك الخاص",
  Select: "اختر",
  Recomended: "موصى به",
  "Our company's identity and actions": "هوية وأفعال شركتنا",
  "Who We Are": "من نحن",
  "We are a trusted platform that bridges the gap between individuals or businesses and their online presence. Our mission is to empower clients to create, customize, and control their online identity with minimal effort. Whether you're looking to buy a domain, use an existing one, or launch a fully customizable website, our platform provides the tools, support, and flexibility to make it happen. We are more than just a service provider; we are your partner in building a powerful online presence, ensuring scalability, security, and ease of use.":
    "نحن منصة موثوقة تعمل على سد الفجوة بين الأفراد أو الشركات وحضورهم على الإنترنت. مهمتنا هي تمكين العملاء من إنشاء وتخصيص والتحكم في هويتهم عبر الإنترنت بأقل جهد ممكن. سواء كنت تبحث عن شراء نطاق، أو استخدام نطاق موجود، أو إطلاق موقع ويب قابل للتخصيص بالكامل، فإن منصتنا توفر الأدوات والدعم والمرونة لجعل ذلك ممكنًا. نحن أكثر من مجرد مزود خدمة؛ نحن شريكك في بناء حضور قوي عبر الإنترنت، مع ضمان التوسع، الأمان، وسهولة الاستخدام.",
  "Our Services": "خدماتنا",
  "Domain Services": "خدمات النطاقات",
  "Domain Purchase:": ":شراء النطاق",
  "Help clients search, purchase, and secure their perfect domain.":
    "مساعدة العملاء في البحث عن نطاق مثالي وشرائه وتأمينه.",
  "Domain Transfer:": "نقل النطاق",
  "Seamless transfer of existing domains to our platform with 24/7 support.":
    "نقل النطاقات الحالية إلى منصتنا بسهولة مع دعم على مدار الساعة.",
  "Domain Management:": ":إدارة النطاق",
  "Tools to manage DNS settings, subdomains, and email setups.":
    "أدوات لإدارة إعدادات DNS والنطاقات الفرعية وإعدادات البريد الإلكتروني.",
  "Website Creation": "إنشاء المواقع",
  "Pre-Built Templates:": ":القوالب الجاهزة",
  "Hosting Services": "خدمات الاستضافة",
  "Scalable Hosting Plans:": ":خطط استضافة قابلة للتطوير",
  "Content Management": "إدارة المحتوى",
  "Built-In CMS:": ":نظام إدارة المحتوى المدمج",
  "Social Media Integration:": ":تكامل وسائل التواصل الاجتماعي",
  "Customer can integrate social media accounts for website.":
    ".يمكن للعملاء دمج حسابات وسائل التواصل الاجتماعي مع الموقع الإلكتروني",
  "A library of professionally designed templates for every industry.":
    ".مكتبة من القوالب المصممة بشكل احترافي لكل صناعة",
  "From shared hosting to dedicated servers.":
    ".من الاستضافة المشتركة إلى الخوادم المخصصة",
  "One-Click Installations:": ":التثبيت بنقرة واحدة",
  "CDN Integration:": ":تكامل شبكات توصيل المحتوى (CDN)",
  "Install popular platforms like WordPress, Joomla, or Magento with ease.":
    ".قم بتثبيت المنصات الشهيرة مثل WordPress أو Joomla أو Magento بسهولة",
  "Speed up your site with integrated content delivery networks.":
    ".قم بتسريع موقعك باستخدام شبكات توصيل المحتوى المدمجة",
  "Manage content easily through our intuitive dashboard.":
    ".قم بإدارة المحتوى بسهولة من خلال لوحة التحكم البديهية الخاصة بنا",
  "SEO Tools:": ":أدوات تحسين محركات البحث (SEO)",
  "Integrated tools to help your website rank higher on search engines.":
    ".أدوات مدمجة تساعد موقعك على تحسين ترتيبه في محركات البحث",
  "E-Commerce Features:": ":ميزات التجارة الإلكترونية",
  "Enable online stores with payment gateways, inventory management, and more.":
    ".تفعيل المتاجر الإلكترونية مع بوابات الدفع وإدارة المخزون والمزيد",
  "Email is required": "البريد الإلكتروني مطلوب",
  "Message is required": "الرسالة مطلوبة",
  "Name is required": "الاسم مطلوب",
  "Name must be at least 3 characters long":"يجب أن يكون الاسم مكونًا من 3 أحرف على الأقل",
};

export default ar;
